import React from "react";
import {
  AboutClasses,
  HeroClasses,
  SkillsClasses,
  TrialBar,
  TechRequiredClasses,
  PricingClasses,
} from "../../components";
import { aboutart, coding, darthero } from "../../assets/images";
import { Helmet } from "react-helmet";

const DArtClass = () => {
  return (
    <div className="md:pt-4 pt-0">
      <Helmet>
        <title>3D Digital Art Classes for Kids | TechTails</title>
        <meta
          name="description"
          content="Unlock your child's creative potential with TechTails 3D Digital Art Classes. From imagination to digital creation, make screen time educational and fun."
        />
        <meta
          property="og:title"
          content="3D Digital Art Classes for Kids | TechTails"
        />
        <meta
          property="og:description"
          content="Transform screen time into a creative journey with our 3D Digital Art classes. Dive into 3D modeling and sculpting, and watch your child's imagination come to life."
        />
      </Helmet>
      <HeroClasses
        title="3D Digital Art"
        tagline="Master 3D Modeling & Digital Creation"
        desc="Your child will learn professional 3D modeling and digital art using industry-standard tools like Blender. They'll create characters, environments, and animations, gaining skills used in movies, games, and digital design."
        img={darthero}
      />
      <AboutClasses
        title="What They'll Learn"
        desc="Students learn 3D modeling fundamentals, sculpting techniques, texturing, and basic animation. They'll create everything from simple objects to complex characters, understanding how digital art is made for games, films, and professional projects."
        image={aboutart}
      />
      <SkillsClasses
        title="Level Up Your Child's Skills"
        desc="Boost your kid's skills in a fun and cool way with our 3D Digital Art class!"
      />
      <PricingClasses
        title="Private 1:1 Pricing"
        desc="Our pricing is discounted as we enter the early stages of welcoming new students."
      />
      <TechRequiredClasses />
    </div>
  );
};

export default DArtClass;
